export default "__VITE_ASSET__BCjsXQUx__"